module.exports = __webpack_public_path__ + "img/7.98d0f61c.jpg";